import Car2 from '../img/Car2.jpg'
import Car3 from '../img/Car3.jpg'
import Car4 from '../img/Car4.jpg'
import Car1 from '../img/Car1.jpg'
import House1 from '../img/house1.jpg'
import House2 from '../img/house2.jpg'
import LastOne from '../img/Footer.jpg'

const Data = [
  {
    title: 'Model S',
    desc: 'Order Online for',
    descLink: 'Touchless Delivery',
    fButton: 'CUSTOM ORDER',
    sButton: 'EXISTING INVENTORY',
    car: Car3,
    bgPosition: 'center',
    bgAttachment: 'fixed',
    bgSize: 'cover',
    display: 'block',
  },
  {
    title: 'Model X',
    desc: 'Order Online for',
    descLink: 'Touchless Delivery',
    fButton: 'CUSTOM ORDER',
    sButton: 'LEARN MORE',
    car: Car1,
    bgPosition: 'center',
    bgAttachment: 'fixed',
    bgSize: 'cover',
    display: 'block',
  },
  {
    title: 'Model Y',
    desc: 'Order Online for',
    descLink: 'Touchless Delivery',
    fButton: 'CUSTOM ORDER',
    sButton: 'LEARN MORE',
    car: Car2,
    bgPosition: 'center',
    bgAttachment: 'fixed',
    bgSize: 'cover',
    display: 'block',
  },
  {
    title: 'Model 3',
    desc: 'Order Online for',
    descLink: 'Touchless Delivery',
    fButton: 'CUSTOM ORDER',
    sButton: 'LEARN MORE',
    car: Car4,
    bgPosition: 'center',
    bgAttachment: 'fixed',
    bgSize: 'cover',
    display: 'block',
  },
  {
    title: 'Lowest Cost Solar Panels',
    desc: 'Money-back guarantee',
    descLink: '',
    fButton: 'ORDER NOW',
    sButton: 'LEARN MORE',
    car: House1,
    bgPosition: 'center',
    bgAttachment: 'fixed',
    bgSize: 'cover',
    display: 'block',
  },
  {
    title: 'Solar for New Roofs',
    desc: 'Solar Roof Costs Less Than a New Roof Plus Solar Panels',
    descLink: '',
    fButton: 'ORDER NOW',
    sButton: 'LEARN MORE',
    car: House2,
    bgPosition: 'center',
    bgAttachment: 'fixed',
    bgSize: 'cover',
    display: 'block',
  },
  {
    title: 'Accessories',
    desc: '',
    descLink: '',
    fButton: 'ORDER NOW',
    sButton: 'LEARN MORE',
    car: LastOne,
    bgPosition: 'center',
    bgAttachment: 'fixed',
    bgSize: 'cover',
    display: 'none',
  },
]

export default Data
